import {
  BLOG_HELPERS,
  SET_BLOG
} from 'src/store/mutation-types'

export default {
  [BLOG_HELPERS] (state, blogHelpers) {
    state.blogHelpers = blogHelpers
  },
  [SET_BLOG] (state, blog) {
    state.blog = blog
  }
}



// WEBPACK FOOTER //
// ./src/components/blog/store/mutations.js